import React from "react";
import { useState } from "react";
// import closeIcon from "../../../../assets/icons/close_dashlayout_icon.png";
import closeIcon from "../../../../assets/svgs/cross_icon.svg";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import RadioButtonRb from "../../../Buttons/radioButtonRb/radioButtonRb";
import TableRb from "../../../Tables/tableRb";
import AsinsTable from "../../CampaignCreationPages/SP_Product_Targeting/AsinsTable";
import { useEffect } from "react";
import DeleteProductButton from "../../../../assets/images/SP_ProductImage/DeleteProductButton.png";
import AddProductButton from "../../../../assets/svgs/plus_box.svg";
import { useGlobalContext } from "../../../../context/global";
import PrimaryBtnRB from "../../../Buttons/primaryBtnRB.js/primaryBtnRB";
import { useSearchParams } from "react-router-dom";
import { TOAST_DANGER, TOAST_POSITION_TOP_RIGHT,TOAST_SUCCESS } from "../../../../constant/HardTypes";  
import getCampaignData from "../../../../helper/CampaignList/editTargeting/AsynCalls/getCampaignData";
import { masterApi } from "../../../../apis/masterApi";
import {toast} from 'react-toastify';

const AddProductModal = (props) => {
  const [page, setPage] = useState("");
  const [dynamicHeaders, setDynamicHeaders] = useState(["ASINS", "Action"]);
  const [products, setProducts] = useState([]);
  const [addedProducts, setAddedProducts] = useState([]);
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries([...searchParams]);
  const { manuallyAddedAsins, setManuallyAddedAsins,showAlert } = useGlobalContext();
  const getSelectedAdsetCreativesData = useSelector(
    (state) => state.campaignListData.getSelectedAdsetCreativesData
  );
  const { id: creativeId } = getSelectedAdsetCreativesData;
  // const {
  //   adset,
  //   campaignType,
  //   alphanumericAdsetId: adsetId,
  //   alphaNumericCampaignid: campaignId,
  //   currentCampaign,
  // } = editBtnclickedCampaignDetailsForEditTargetingTable;
  const [currentCampaign,setCurrentCampaign] = useState({});
  const { account_id, objective } = currentCampaign;

  const radioChange = (e, value) => {
    const mainBtn = e.target.closest(".redioButton-box");
    const allBtn = mainBtn.querySelectorAll(".redioButton");
    allBtn.forEach((item) => {
      item.classList.remove("active");
    });
    const add = e.target.closest(".redioButton");
    add.classList.add("active");
    add.children[0].children[0].children[0].checked = true;
  };
  const clientId = JSON.parse(localStorage.getItem("clientId"));

  // API Fetching Functions

  const fetchData = async () => {
    const url = `https://catalogapi.adyogi.com/client/${clientId}/products?source=amazon&fields=name,sale_price,asin,image_url`;
    try {
      const result = await fetch(url);
      const data = await result.json();
      const currentCampaignData = await getCampaignData(clientId,params?.campaignId);
      setCurrentCampaign(currentCampaignData);
      setProducts(data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  // Update Ads API Function

  const updateAdCall = async (dataPassed) => {
    const url = `https://adyogiadsapi.adyogi.com/client/${clientId}/ads?source=amazon`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataPassed),
    };
    try {
      const response = await fetch(url, options);
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  // Effects
  useEffect(() => {
    fetchData();
  }, []);

  // Methods
  const handleClose = () => {
    setAddedProducts([]);
    setManuallyAddedAsins([]);
    setPage("");
    props.setIsVisible(false);
  };

  const onAddProduct = (id) => {
    const recievedProduct = products.filter((product) => {
      return product.asin === id;
    });
    const { asin } = recievedProduct[0];
    const isProductThere = addedProducts.filter((product) => {
      return product.asin === asin;
    });
    if (isProductThere.length === 0) {
      setAddedProducts([...addedProducts, recievedProduct[0]]);
    } else {
      alert("The Product is already added");
    }
  };

  const onDeleteProduct = (id) => {
    setAddedProducts((current) => {
      return current.filter((product) => {
        return product.asin !== id;
      });
    });
  };

  const handleAsinDelete = (id) => {
    setManuallyAddedAsins((current) => {
      return current.filter((asin) => {
        return asin.id !== id;
      });
    });
  };

  const deleteAllAsins = () => {
    setManuallyAddedAsins([]);
  };

  const removeAllProducts = () => {
    setAddedProducts([]);
  };

  const prepareModifiedProduct = (product, asin) => {
    const modifiedProduct = {
      account_id: account_id ?? JSON.parse(localStorage.getItem("accountId")),
      client_id: clientId,
      type: objective,
      campaign_id: params?.campaignId,
      adset_id: params?.adsetId,
      creative_id: creativeId,
      source: "amazon",
      status: "ENABLED",
      asin: asin,
    };
    return modifiedProduct;
  };

  const filterPausedAsins = (asins) => {
    return props?.alreadyAddedAsins?.filter((data) => {
      const isPaused = asins.find(
        (addedAsin) =>
          addedAsin?.toLowerCase() === data?.asin?.toLowerCase() &&
          data?.status === "PAUSED"
      );
      return isPaused;
    });
  };

  const processProducts = (products, asinKey) => {
    const asins = products.map((product) => product[asinKey]);
    const addedAsins = asins.map((addedAsin) => addedAsin);
    return {
      filteredAsins: filterPausedAsins(addedAsins),
    };
  };

  const updateAds = async () => {
    // Check on which page user is.
    const isProduct = page === "first" ? true : false
    let dataToBePassedInAPI = isProduct
    ? addedProducts.map((product) => prepareModifiedProduct(product, product.asin))
    : manuallyAddedAsins.map((product) => prepareModifiedProduct(product, product.id));
    const alreadyAddedAsins = props?.alreadyAddedAsins
    const {filteredAsins} = processProducts(isProduct?addedProducts:manuallyAddedAsins,isProduct?"asin":'id')
    // Check if there is any paused asins which needs to be enabled if there is then enable those asins
    if(filteredAsins?.length) {
      const payloadData = {status:"enabled", 
        asins:filteredAsins?.map((asin) => asin?.asin),
        email: localStorage.getItem("email") ?? ""
        }
      const result = await masterApi(payloadData, "uploadasinsstatus", false, "post");
      if (result?.statusCode !== 200) {
        // showAlert(TOAST_POSITION_TOP_RIGHT, 10000, {
        //   backgroundColor: TOAST_DANGER,
        //   title: "Success",
        //   description: "Error While upload asin",
        // });
        toast.error('Error while uploading asin')
      } else {
        // showAlert(TOAST_POSITION_TOP_RIGHT, 10000, {
        //   backgroundColor: TOAST_SUCCESS,
        //   title: "Success",
        //   description: `Ads Updated Successfully! \n Please check status after sometime!`,
        // });
        toast.success('Ads Updated successfully! Please check after sometime')
        props.setIsNewAdsetCreated(!props.isNewAdsetCreated) 
      }
      
    }

    dataToBePassedInAPI =  dataToBePassedInAPI?.filter((data) => {
      const isAlreadyAdded = alreadyAddedAsins?.find(
        (asin) => asin?.asin?.toLowerCase() === data?.asin?.toLowerCase()
      );
      return !isAlreadyAdded;
    });
    // If there is an ASIN Left Which is not part of the above already added asins
    if(dataToBePassedInAPI?.length) {
      const result = await updateAdCall(dataToBePassedInAPI);
      if ("id" in result[0]) {
        handleClose();
        // showAlert(TOAST_POSITION_TOP_RIGHT, 3000, {
        //   backgroundColor: TOAST_SUCCESS,
        //   title: "Success",
        //   description: `Ads Updated Successfully! \n Please check status after sometime!`,
        // });
        toast.success(`Ads Updated Successfully!Please check status after sometime!`)
        props.setIsNewAdsetCreated(!props.isNewAdsetCreated)  
      } else {
        alert("Error while updating");
      }
    } else {
      props.setIsNewAdsetCreated(!props.isNewAdsetCreated)  
      handleClose();
    }
   
  };

  // Table Bodies
  let tableBody = (
    <>
      <div className="generic-main-table-body-container">
        <table className="sp-product-targetting-table">
          <thead className="main-table-head">
            <tr className="table-heading-style">
              <td colspan={3} className="table-upper">
                <div className="float-left p-3">0 Added</div>
                <div className="float-right">
                  {/* <button
                      type="button"
                     
                      className="remove-all-btn"
                    >
                      Remove All
                    </button> */}
                </div>
              </td>
            </tr>
            <tr>
              <th className="border border-right-white product-table-first">
                <span className="table-header-text mx-3">All Products</span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_1178_14756"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_1178_14756)">
                    <path
                      d="M9.99992 17.9168C8.9027 17.9168 7.87159 17.7085 6.90659 17.2918C5.94103 16.8752 5.10409 16.3127 4.39575 15.6043C3.68742 14.896 3.12492 14.0591 2.70825 13.0935C2.29159 12.1285 2.08325 11.0974 2.08325 10.0002C2.08325 8.90294 2.29159 7.87155 2.70825 6.906C3.12492 5.941 3.68742 5.10433 4.39575 4.396C5.10409 3.68766 5.94103 3.12516 6.90659 2.7085C7.87159 2.29183 8.9027 2.0835 9.99992 2.0835C11.0971 2.0835 12.1285 2.29183 13.0941 2.7085C14.0591 3.12516 14.8958 3.68766 15.6041 4.396C16.3124 5.10433 16.8749 5.941 17.2916 6.906C17.7083 7.87155 17.9166 8.90294 17.9166 10.0002C17.9166 11.0974 17.7083 12.1285 17.2916 13.0935C16.8749 14.0591 16.3124 14.896 15.6041 15.6043C14.8958 16.3127 14.0591 16.8752 13.0941 17.2918C12.1285 17.7085 11.0971 17.9168 9.99992 17.9168ZM9.99992 16.6668C11.8471 16.6668 13.4202 16.0177 14.7191 14.7193C16.0174 13.4204 16.6666 11.8474 16.6666 10.0002C16.6666 8.15294 16.0174 6.57989 14.7191 5.281C13.4202 3.98266 11.8471 3.3335 9.99992 3.3335C8.1527 3.3335 6.57992 3.98266 5.28158 5.281C3.9827 6.57989 3.33325 8.15294 3.33325 10.0002C3.33325 11.8474 3.9827 13.4204 5.28158 14.7193C6.57992 16.0177 8.1527 16.6668 9.99992 16.6668Z"
                      fill="white"
                    />
                    <path
                      d="M9.97331 13.9585C10.1539 13.9585 10.3033 13.8996 10.4216 13.7818C10.5394 13.6635 10.5983 13.5141 10.5983 13.3335V9.771C10.5983 9.60433 10.5394 9.46183 10.4216 9.3435C10.3033 9.22572 10.1539 9.16683 9.97331 9.16683C9.79275 9.16683 9.64359 9.22572 9.52581 9.3435C9.40747 9.46183 9.34831 9.61127 9.34831 9.79183V13.3543C9.34831 13.521 9.40747 13.6635 9.52581 13.7818C9.64359 13.8996 9.79275 13.9585 9.97331 13.9585ZM9.97331 7.75016C10.1678 7.75016 10.3275 7.68405 10.4525 7.55183C10.5775 7.42016 10.64 7.25711 10.64 7.06266C10.64 6.88211 10.5775 6.72572 10.4525 6.5935C10.3275 6.46183 10.1678 6.396 9.97331 6.396C9.77886 6.396 9.61914 6.46183 9.49414 6.5935C9.36914 6.72572 9.30664 6.88211 9.30664 7.06266C9.30664 7.25711 9.36914 7.42016 9.49414 7.55183C9.61914 7.68405 9.77886 7.75016 9.97331 7.75016Z"
                      fill="white"
                    />
                  </g>
                </svg>
              </th>
              <th id="product-table-header">
                <div className="d-flex justify-content-between align-items-center">
                  <span>
                    <span className="table-header-text mx-3">Details</span>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_1178_14756"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_1178_14756)">
                        <path
                          d="M9.99992 17.9168C8.9027 17.9168 7.87159 17.7085 6.90659 17.2918C5.94103 16.8752 5.10409 16.3127 4.39575 15.6043C3.68742 14.896 3.12492 14.0591 2.70825 13.0935C2.29159 12.1285 2.08325 11.0974 2.08325 10.0002C2.08325 8.90294 2.29159 7.87155 2.70825 6.906C3.12492 5.941 3.68742 5.10433 4.39575 4.396C5.10409 3.68766 5.94103 3.12516 6.90659 2.7085C7.87159 2.29183 8.9027 2.0835 9.99992 2.0835C11.0971 2.0835 12.1285 2.29183 13.0941 2.7085C14.0591 3.12516 14.8958 3.68766 15.6041 4.396C16.3124 5.10433 16.8749 5.941 17.2916 6.906C17.7083 7.87155 17.9166 8.90294 17.9166 10.0002C17.9166 11.0974 17.7083 12.1285 17.2916 13.0935C16.8749 14.0591 16.3124 14.896 15.6041 15.6043C14.8958 16.3127 14.0591 16.8752 13.0941 17.2918C12.1285 17.7085 11.0971 17.9168 9.99992 17.9168ZM9.99992 16.6668C11.8471 16.6668 13.4202 16.0177 14.7191 14.7193C16.0174 13.4204 16.6666 11.8474 16.6666 10.0002C16.6666 8.15294 16.0174 6.57989 14.7191 5.281C13.4202 3.98266 11.8471 3.3335 9.99992 3.3335C8.1527 3.3335 6.57992 3.98266 5.28158 5.281C3.9827 6.57989 3.33325 8.15294 3.33325 10.0002C3.33325 11.8474 3.9827 13.4204 5.28158 14.7193C6.57992 16.0177 8.1527 16.6668 9.99992 16.6668Z"
                          fill="white"
                        />
                        <path
                          d="M9.97331 13.9585C10.1539 13.9585 10.3033 13.8996 10.4216 13.7818C10.5394 13.6635 10.5983 13.5141 10.5983 13.3335V9.771C10.5983 9.60433 10.5394 9.46183 10.4216 9.3435C10.3033 9.22572 10.1539 9.16683 9.97331 9.16683C9.79275 9.16683 9.64359 9.22572 9.52581 9.3435C9.40747 9.46183 9.34831 9.61127 9.34831 9.79183V13.3543C9.34831 13.521 9.40747 13.6635 9.52581 13.7818C9.64359 13.8996 9.79275 13.9585 9.97331 13.9585ZM9.97331 7.75016C10.1678 7.75016 10.3275 7.68405 10.4525 7.55183C10.5775 7.42016 10.64 7.25711 10.64 7.06266C10.64 6.88211 10.5775 6.72572 10.4525 6.5935C10.3275 6.46183 10.1678 6.396 9.97331 6.396C9.77886 6.396 9.61914 6.46183 9.49414 6.5935C9.36914 6.72572 9.30664 6.88211 9.30664 7.06266C9.30664 7.25711 9.36914 7.42016 9.49414 7.55183C9.61914 7.68405 9.77886 7.75016 9.97331 7.75016Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </span>
                  <svg
                    width="19"
                    height="12"
                    viewBox="0 0 19 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="menu-icon-table"
                  >
                    <path
                      d="M1.36328 11.625C1.14661 11.625 0.967615 11.5543 0.826281 11.413C0.684281 11.271 0.613281 11.0917 0.613281 10.875C0.613281 10.675 0.684281 10.5 0.826281 10.35C0.967615 10.2 1.14661 10.125 1.36328 10.125H17.3633C17.5799 10.125 17.7593 10.2 17.9013 10.35C18.0426 10.5 18.1133 10.675 18.1133 10.875C18.1133 11.0917 18.0426 11.271 17.9013 11.413C17.7593 11.5543 17.5799 11.625 17.3633 11.625H1.36328ZM1.36328 6.75C1.14661 6.75 0.967615 6.679 0.826281 6.537C0.684281 6.39567 0.613281 6.21667 0.613281 6C0.613281 5.78333 0.684281 5.604 0.826281 5.462C0.967615 5.32067 1.14661 5.25 1.36328 5.25H17.3633C17.5799 5.25 17.7593 5.32067 17.9013 5.462C18.0426 5.604 18.1133 5.78333 18.1133 6C18.1133 6.21667 18.0426 6.39567 17.9013 6.537C17.7593 6.679 17.5799 6.75 17.3633 6.75H1.36328ZM1.36328 1.875C1.14661 1.875 0.967615 1.8 0.826281 1.65C0.684281 1.5 0.613281 1.325 0.613281 1.125C0.613281 0.908333 0.684281 0.729333 0.826281 0.588C0.967615 0.446 1.14661 0.375 1.36328 0.375H17.3633C17.5799 0.375 17.7593 0.446 17.9013 0.588C18.0426 0.729333 18.1133 0.908333 18.1133 1.125C18.1133 1.325 18.0426 1.5 17.9013 1.65C17.7593 1.8 17.5799 1.875 17.3633 1.875H1.36328Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </th>
            </tr>
          </thead>

          <tbody className="table-body main-table-body">
            {products &&
              products.map((product, index) => {
                return (
                  <>
                    <tr key={Math.random() * 10000} className="row-height">
                      <td className="tabledata-tb">
                        <Product
                          image={product.image_url}
                          Name={product.name}
                          Desc={product.sale_price}
                        />
                      </td>
                      <td className="tabledata-tb bids-parent-container">
                        <div className="bids-container">
                          <span>{product.asin}</span>
                          {/* <span className={campaignType==="SP-Product"?"d-none":""}>{category.bid}</span> */}
                          {/* <span>{category.name}</span> */}
                        </div>
                        <span className="cursor-pointer-global selected-icon-hover">
                          <img
                            src={AddProductButton}
                            onClick={() => onAddProduct(product.asin)}
                            alt="productaddButton"
                          />
                        </span>
                      </td>
                    </tr>
                  </>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );

  let tableBodyAdded = (
    <>
      <div className="generic-main-table-body-container">
        <table className="sp-product-targetting-table">
          <thead className="main-table-head">
            <tr className="table-heading-style">
              <td colspan={3} className="table-upper">
                <div className="float-left p-3">0 Added</div>
                <div className="float-right">
                  <button
                    type="button"
                    onClick={removeAllProducts}
                    className={
                      addedProducts && addedProducts.length !== 0
                        ? "remove-all-btn-dark"
                        : "remove-all-btn"
                    }
                  >
                    Remove All
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <th className="border border-right-white product-table-first">
                <span className="table-header-text mx-3">Added Products</span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_1178_14756"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_1178_14756)">
                    <path
                      d="M9.99992 17.9168C8.9027 17.9168 7.87159 17.7085 6.90659 17.2918C5.94103 16.8752 5.10409 16.3127 4.39575 15.6043C3.68742 14.896 3.12492 14.0591 2.70825 13.0935C2.29159 12.1285 2.08325 11.0974 2.08325 10.0002C2.08325 8.90294 2.29159 7.87155 2.70825 6.906C3.12492 5.941 3.68742 5.10433 4.39575 4.396C5.10409 3.68766 5.94103 3.12516 6.90659 2.7085C7.87159 2.29183 8.9027 2.0835 9.99992 2.0835C11.0971 2.0835 12.1285 2.29183 13.0941 2.7085C14.0591 3.12516 14.8958 3.68766 15.6041 4.396C16.3124 5.10433 16.8749 5.941 17.2916 6.906C17.7083 7.87155 17.9166 8.90294 17.9166 10.0002C17.9166 11.0974 17.7083 12.1285 17.2916 13.0935C16.8749 14.0591 16.3124 14.896 15.6041 15.6043C14.8958 16.3127 14.0591 16.8752 13.0941 17.2918C12.1285 17.7085 11.0971 17.9168 9.99992 17.9168ZM9.99992 16.6668C11.8471 16.6668 13.4202 16.0177 14.7191 14.7193C16.0174 13.4204 16.6666 11.8474 16.6666 10.0002C16.6666 8.15294 16.0174 6.57989 14.7191 5.281C13.4202 3.98266 11.8471 3.3335 9.99992 3.3335C8.1527 3.3335 6.57992 3.98266 5.28158 5.281C3.9827 6.57989 3.33325 8.15294 3.33325 10.0002C3.33325 11.8474 3.9827 13.4204 5.28158 14.7193C6.57992 16.0177 8.1527 16.6668 9.99992 16.6668Z"
                      fill="white"
                    />
                    <path
                      d="M9.97331 13.9585C10.1539 13.9585 10.3033 13.8996 10.4216 13.7818C10.5394 13.6635 10.5983 13.5141 10.5983 13.3335V9.771C10.5983 9.60433 10.5394 9.46183 10.4216 9.3435C10.3033 9.22572 10.1539 9.16683 9.97331 9.16683C9.79275 9.16683 9.64359 9.22572 9.52581 9.3435C9.40747 9.46183 9.34831 9.61127 9.34831 9.79183V13.3543C9.34831 13.521 9.40747 13.6635 9.52581 13.7818C9.64359 13.8996 9.79275 13.9585 9.97331 13.9585ZM9.97331 7.75016C10.1678 7.75016 10.3275 7.68405 10.4525 7.55183C10.5775 7.42016 10.64 7.25711 10.64 7.06266C10.64 6.88211 10.5775 6.72572 10.4525 6.5935C10.3275 6.46183 10.1678 6.396 9.97331 6.396C9.77886 6.396 9.61914 6.46183 9.49414 6.5935C9.36914 6.72572 9.30664 6.88211 9.30664 7.06266C9.30664 7.25711 9.36914 7.42016 9.49414 7.55183C9.61914 7.68405 9.77886 7.75016 9.97331 7.75016Z"
                      fill="white"
                    />
                  </g>
                </svg>
              </th>
              <th id="product-table-header">
                <div className="d-flex justify-content-between align-items-center">
                  <span>
                    <span className="table-header-text mx-3"> Details</span>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_1178_14756"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_1178_14756)">
                        <path
                          d="M9.99992 17.9168C8.9027 17.9168 7.87159 17.7085 6.90659 17.2918C5.94103 16.8752 5.10409 16.3127 4.39575 15.6043C3.68742 14.896 3.12492 14.0591 2.70825 13.0935C2.29159 12.1285 2.08325 11.0974 2.08325 10.0002C2.08325 8.90294 2.29159 7.87155 2.70825 6.906C3.12492 5.941 3.68742 5.10433 4.39575 4.396C5.10409 3.68766 5.94103 3.12516 6.90659 2.7085C7.87159 2.29183 8.9027 2.0835 9.99992 2.0835C11.0971 2.0835 12.1285 2.29183 13.0941 2.7085C14.0591 3.12516 14.8958 3.68766 15.6041 4.396C16.3124 5.10433 16.8749 5.941 17.2916 6.906C17.7083 7.87155 17.9166 8.90294 17.9166 10.0002C17.9166 11.0974 17.7083 12.1285 17.2916 13.0935C16.8749 14.0591 16.3124 14.896 15.6041 15.6043C14.8958 16.3127 14.0591 16.8752 13.0941 17.2918C12.1285 17.7085 11.0971 17.9168 9.99992 17.9168ZM9.99992 16.6668C11.8471 16.6668 13.4202 16.0177 14.7191 14.7193C16.0174 13.4204 16.6666 11.8474 16.6666 10.0002C16.6666 8.15294 16.0174 6.57989 14.7191 5.281C13.4202 3.98266 11.8471 3.3335 9.99992 3.3335C8.1527 3.3335 6.57992 3.98266 5.28158 5.281C3.9827 6.57989 3.33325 8.15294 3.33325 10.0002C3.33325 11.8474 3.9827 13.4204 5.28158 14.7193C6.57992 16.0177 8.1527 16.6668 9.99992 16.6668Z"
                          fill="white"
                        />
                        <path
                          d="M9.97331 13.9585C10.1539 13.9585 10.3033 13.8996 10.4216 13.7818C10.5394 13.6635 10.5983 13.5141 10.5983 13.3335V9.771C10.5983 9.60433 10.5394 9.46183 10.4216 9.3435C10.3033 9.22572 10.1539 9.16683 9.97331 9.16683C9.79275 9.16683 9.64359 9.22572 9.52581 9.3435C9.40747 9.46183 9.34831 9.61127 9.34831 9.79183V13.3543C9.34831 13.521 9.40747 13.6635 9.52581 13.7818C9.64359 13.8996 9.79275 13.9585 9.97331 13.9585ZM9.97331 7.75016C10.1678 7.75016 10.3275 7.68405 10.4525 7.55183C10.5775 7.42016 10.64 7.25711 10.64 7.06266C10.64 6.88211 10.5775 6.72572 10.4525 6.5935C10.3275 6.46183 10.1678 6.396 9.97331 6.396C9.77886 6.396 9.61914 6.46183 9.49414 6.5935C9.36914 6.72572 9.30664 6.88211 9.30664 7.06266C9.30664 7.25711 9.36914 7.42016 9.49414 7.55183C9.61914 7.68405 9.77886 7.75016 9.97331 7.75016Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </span>
                  <svg
                    width="19"
                    height="12"
                    viewBox="0 0 19 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="menu-icon-table"
                  >
                    <path
                      d="M1.36328 11.625C1.14661 11.625 0.967615 11.5543 0.826281 11.413C0.684281 11.271 0.613281 11.0917 0.613281 10.875C0.613281 10.675 0.684281 10.5 0.826281 10.35C0.967615 10.2 1.14661 10.125 1.36328 10.125H17.3633C17.5799 10.125 17.7593 10.2 17.9013 10.35C18.0426 10.5 18.1133 10.675 18.1133 10.875C18.1133 11.0917 18.0426 11.271 17.9013 11.413C17.7593 11.5543 17.5799 11.625 17.3633 11.625H1.36328ZM1.36328 6.75C1.14661 6.75 0.967615 6.679 0.826281 6.537C0.684281 6.39567 0.613281 6.21667 0.613281 6C0.613281 5.78333 0.684281 5.604 0.826281 5.462C0.967615 5.32067 1.14661 5.25 1.36328 5.25H17.3633C17.5799 5.25 17.7593 5.32067 17.9013 5.462C18.0426 5.604 18.1133 5.78333 18.1133 6C18.1133 6.21667 18.0426 6.39567 17.9013 6.537C17.7593 6.679 17.5799 6.75 17.3633 6.75H1.36328ZM1.36328 1.875C1.14661 1.875 0.967615 1.8 0.826281 1.65C0.684281 1.5 0.613281 1.325 0.613281 1.125C0.613281 0.908333 0.684281 0.729333 0.826281 0.588C0.967615 0.446 1.14661 0.375 1.36328 0.375H17.3633C17.5799 0.375 17.7593 0.446 17.9013 0.588C18.0426 0.729333 18.1133 0.908333 18.1133 1.125C18.1133 1.325 18.0426 1.5 17.9013 1.65C17.7593 1.8 17.5799 1.875 17.3633 1.875H1.36328Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </th>
            </tr>
          </thead>

          <tbody className="table-body main-table-body">
            {addedProducts &&
              addedProducts.map((product, index) => {
                return (
                  <>
                    <tr key={Math.random() * 10000} className="row-height">
                      <td className="tabledata-tb">
                        <Product
                          image={product.image_url}
                          Name={product.name}
                          Desc={product.sale_price}
                        />
                      </td>
                      <td className="tabledata-tb bids-parent-container">
                        <div className="bids-container">
                          <span>{product.asin}</span>
                          {/* <span className={campaignType==="SP-Product"?"d-none":""}>{category.bid}</span> */}
                          {/* <span>{category.name}</span> */}
                        </div>
                        <span className="cursor-pointer-global selected-icon-hover">
                          <img
                            src={DeleteProductButton}
                            onClick={() => onDeleteProduct(product.asin)}
                            alt="productaddButton"
                          />
                        </span>
                      </td>
                    </tr>
                  </>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );

  const tableBody1 = (
    <>
      <div className="generic-main-table-body-container">
        <table className="addetails-asins-table">
          <thead className="main-table-head">
            <tr className="table-heading-style">
              <td colspan={3} className="table-upper">
                <div className="float-left text-dark p-3"> Added</div>
                <div className="float-right">
                  <button
                    type="button"
                    onClick={deleteAllAsins}
                    className={
                      manuallyAddedAsins && manuallyAddedAsins.length !== 0
                        ? "remove-all-btn-dark"
                        : "remove-all-btn"
                    }
                  >
                    Remove All
                  </button>
                </div>
              </td>
            </tr>
            <tr style={{ height: "44px" }}>
              {dynamicHeaders.map((th, index) => {
                if (index === dynamicHeaders.length - 1) {
                  return (
                    <th
                      className="border border-right-white"
                      onClick={() => {
                        // setIsVisible(true)
                      }}
                    >
                      {th}
                    </th>
                  );
                }
                return (
                  <th
                    className="border border-right-white"
                    style={{ textAlign: "left", paddingLeft: "30px" }}
                  >
                    {th}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody className="table-body main-table-body">
            {manuallyAddedAsins &&
              manuallyAddedAsins.map((word, index) => {
                return (
                  <tr key={word.id} className="row-height">
                    <td
                      className="tabledata-td"
                      style={{ textAlign: "left", paddingLeft: "30px" }}
                    >
                      ID:- {word.id}
                    </td>
                    <td className="tabledata-td" style={{ cursor: "pointer" }}>
                      <img
                        src={DeleteProductButton}
                        alt="deleteIcon"
                        onClick={() => handleAsinDelete(word.id)}
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );

  return (
    <>
      <div className="wrapper-modal-add-product">
        <Modal
          className="modal-wrapper"
          show={props.isVisible}
          onHide={handleClose}
        >
          <Modal.Body>
            <>
              <div
                className="key-wrap"
                style={{ paddingLeft: "20px", position: "relative" }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span className="common-head">
                    Update Products
                    <svg
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_1178_14743"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="21"
                        height="20"
                      >
                        <rect
                          x="0.585693"
                          y="0.0175781"
                          width="20"
                          height="19.9643"
                          fill="#D9D9D9"
                        />
                      </mask>
                      <g mask="url(#mask0_1178_14743)">
                        <path
                          d="M10.5856 17.9022C9.48839 17.9022 8.45728 17.6943 7.49228 17.2783C6.52672 16.8624 5.68978 16.3009 4.98145 15.5939C4.27311 14.8868 3.71061 14.0513 3.29395 13.0875C2.87728 12.1242 2.66895 11.095 2.66895 9.9997C2.66895 8.90443 2.87728 7.87489 3.29395 6.91106C3.71061 5.94778 4.27311 5.11261 4.98145 4.40554C5.68978 3.69847 6.52672 3.13697 7.49228 2.72105C8.45728 2.30513 9.48839 2.09717 10.5856 2.09717C11.6828 2.09717 12.7142 2.30513 13.6798 2.72105C14.6448 3.13697 15.4814 3.69847 16.1898 4.40554C16.8981 5.11261 17.4606 5.94778 17.8773 6.91106C18.2939 7.87489 18.5023 8.90443 18.5023 9.9997C18.5023 11.095 18.2939 12.1242 17.8773 13.0875C17.4606 14.0513 16.8981 14.8868 16.1898 15.5939C15.4814 16.3009 14.6448 16.8624 13.6798 17.2783C12.7142 17.6943 11.6828 17.9022 10.5856 17.9022ZM10.5856 16.6545C12.4328 16.6545 14.0059 16.0065 15.3048 14.7104C16.6031 13.4139 17.2523 11.8436 17.2523 9.9997C17.2523 8.15577 16.6031 6.58553 15.3048 5.28896C14.0059 3.99294 12.4328 3.34494 10.5856 3.34494C8.73839 3.34494 7.16561 3.99294 5.86728 5.28896C4.56839 6.58553 3.91895 8.15577 3.91895 9.9997C3.91895 11.8436 4.56839 13.4139 5.86728 14.7104C7.16561 16.0065 8.73839 16.6545 10.5856 16.6545Z"
                          fill="#4D4184"
                        />
                        <path
                          d="M10.559 13.9509C10.7396 13.9509 10.889 13.8921 11.0073 13.7745C11.1251 13.6564 11.184 13.5072 11.184 13.327V9.77083C11.184 9.60446 11.1251 9.46221 11.0073 9.34409C10.889 9.22652 10.7396 9.16774 10.559 9.16774C10.3784 9.16774 10.2293 9.22652 10.1115 9.34409C9.99317 9.46221 9.934 9.61139 9.934 9.79162V13.3478C9.934 13.5141 9.99317 13.6564 10.1115 13.7745C10.2293 13.8921 10.3784 13.9509 10.559 13.9509ZM10.559 7.7536C10.7534 7.7536 10.9132 7.68761 11.0382 7.55562C11.1632 7.42419 11.2257 7.26143 11.2257 7.06733C11.2257 6.8871 11.1632 6.73099 11.0382 6.599C10.9132 6.46757 10.7534 6.40186 10.559 6.40186C10.3646 6.40186 10.2048 6.46757 10.0798 6.599C9.95483 6.73099 9.89233 6.8871 9.89233 7.06733C9.89233 7.26143 9.95483 7.42419 10.0798 7.55562C10.2048 7.68761 10.3646 7.7536 10.559 7.7536Z"
                          fill="#4D4184"
                        />
                      </g>
                    </svg>
                  </span>
                  <span style={{ paddingRight: "30px", paddingTop: "20px" }}>
                    <img
                      src={closeIcon}
                      onClick={handleClose}
                      style={{ width: "15px" }}
                    ></img>
                  </span>
                </div>
              </div>
              <div className="key-wrap smart-logic">
                <div className="redioButton-box">
                  <div className="row">
                    <div className="col-lg-6">
                      <div
                        className="redioButton"
                        id="second"
                        onClick={(e) => {
                          radioChange(e);
                          setPage("first");
                        }}
                      >
                        <RadioButtonRb
                          name="select-Campaign-addetails"
                          label={<Leavle heading="Manual Product Selection" />}
                        ></RadioButtonRb>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div
                        className="redioButton"
                        id="third"
                        onClick={(e) => {
                          radioChange(e);
                          setPage("second");
                        }}
                      >
                        <RadioButtonRb
                          name="select-Campaign-addetails"
                          label={<Leavle heading="Enter ASIN" />}
                        ></RadioButtonRb>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={page === "first" ? "d-block" : "d-none"}>
                <div className="row">
                  <div className="col-lg-6 sp-product-targettig-outer-container">
                    <TableRb table={tableBody}></TableRb>
                  </div>
                  <div className="col-lg-6 sp-product-targettig-outer-container">
                    <TableRb table={tableBodyAdded} />
                  </div>
                </div>
              </div>
              <div className={page === "second" ? "d-block" : "d-none"}>
                <div className="row">
                  <div className="col-lg-6 asin-div">
                    <AsinsTable
                      updateProducts={"updateProducts"}
                      ManuallyAsins={"manuallyasins"}
                    />
                  </div>
                  <div className="col-lg-6 asin-div">
                    <TableRb table={tableBody1} className={" asin-table"}/>
                  </div>
                </div>
              </div>
              <div
                className="d-flex justify-content-end gap-10 keyword-targeting"
                style={{
                  marginTop: "30px",
                  marginRight: "30px",
                  paddingBottom: "30px",
                }}
              >
                <button
                  type="button"
                  className="primary-outline-btn btn btn-outline-primary px-5"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <div onClick={updateAds}>
                  <PrimaryBtnRB
                    insideBtnText="Update"
                    id={"create-campaign-btn"}
                    className="width-100"
                  ></PrimaryBtnRB>
                </div>
              </div>
            </>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

const Leavle = ({ heading, para }) => {
  return (
    <>
      <span className="leavle-hover leavle-heading">{heading}</span>
      <br />
      {para && <span className="leavle-hover leavle-para">{para}</span>}
    </>
  );
};

export default AddProductModal;

const Product = ({ image, Name, Desc }) => {
  return (
    <>
      <div className="product-container">
        <div className="product-img-container">
          <img src={image} alt="image" />
        </div>
        <div className="product-description-container">
          <span className="category-heading-update">Product Name</span>
          <span className="product-name">{Name && Name}</span>
          <span className="product-desc">Sale Price:{Desc}</span>
        </div>
      </div>
    </>
  );
};
